import hasKeyInObject from 'core/utils/hasKeyInObject'
import searchKeyEqualToValueInObject from 'core/utils/searchKeyEqualToValueInObject'
import { EARLY_RENEWAL_COMPONENT_NAME } from 'core/components/EarlyRenewal/consts'

export default {
  builderLoading: (state) => state.builderLoading,
  activeRow: (state) => state.activeRow,
  activeColumn: (state) => state.activeColumn,
  currentComponent: (state) => state.currentComponent,
  rowsCount: ({ templates, currentTemplate }) => templates[currentTemplate].rows.length,
  isMobile: ({ currentPlatform }) => currentPlatform === 'mobile',
  currentRows: ({ templates, currentTemplate }) => templates[currentTemplate].rows,
  isNew: ({ templates, currentTemplate }) => {
    const template = templates[currentTemplate]

    return (!template.editMode && template.name === '')
  },
  activeTemplate: (state) => state.templates[state.currentTemplate],
  currentSlotComponents: (state) => state.templates[state.currentTemplate].slotComponents,
  currentSlotComponentsCount: (state) => state.templates[state.currentTemplate].slotComponentsCount,
  currentInCheckoutComponents: (state) => state.templates[state.currentTemplate].inCheckoutComponents,
  hasInCheckoutComponents: (state) => {
    const currentTemplate = state.templates[state.currentTemplate]

    if (currentTemplate.inCheckoutComponents) {
      return currentTemplate.inCheckoutComponents.length
    }
  },
  currentEditForm: (state) => state.currentEditForm,
  currentEditMode: ({ editMode }) => editMode,
  validateHotPayEarlyRenewal: (state) => {
    const hasHotpayEarlyRenewal = hasKeyInObject(EARLY_RENEWAL_COMPONENT_NAME, state.templates)
    const newTemplates = JSON.parse(JSON.stringify(state.templates))

    if (!hasHotpayEarlyRenewal) {
      return false
    }

    const hotpayEarlyRenewal = searchKeyEqualToValueInObject({
      keyToSearch: 'name',
      equalsToValue: EARLY_RENEWAL_COMPONENT_NAME,
      objectToSearch: newTemplates
    })

    const hotpayEarlyRenewalData = hotpayEarlyRenewal.map(device => device.data)

    if (hotpayEarlyRenewalData.length > 1) {
      const firstProduct = hotpayEarlyRenewalData.shift()
      const { product: firstOfferItem = {}, proposal: firstProposalItem = {} } = firstProduct

      const othersProducts = hotpayEarlyRenewalData.filter(item => {
        const { product: otherOfferItem = {}, proposal: otherProposalItem = {} } = item

        const isEqualOffer = firstOfferItem.key === otherOfferItem.key
        const isEqualDiscount = firstProposalItem.discountPercentage === otherProposalItem.discountPercentage
        const isEqualRecurrence = firstProposalItem.recurrences === otherProposalItem.recurrences

        return isEqualOffer && isEqualRecurrence && isEqualDiscount
      })

      if (othersProducts.length === 0) {
        return null
      }
    }

    return hotpayEarlyRenewal.find(Boolean).data
  }
}
